import styled from 'styled-components'
import getLayer from 'styles/layer'
import GlobalMenu from './global-menu'
import ReturnLink from './return-link'
import { useMemo } from 'react'
import { UserRole } from '../schema/user'
import ROUTING_PATH from '../constants/route'
import { useAuthProvider } from '../contexts/auth'
import TopLogo from './top-logo'
import { HeaderHeightPx } from './header'
import { LoginUserMode, LoginUserModeEnum } from 'constants/loginusermode'
import { LOGIN_USER_MODE } from 'constants/common'

export const HeaderContainer = styled.div<{ lum: LoginUserMode }>`
  z-index: ${getLayer('header')};
  top: 0px;
  right: 0px;
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${HeaderHeightPx};
  width: 100%;
  background-color: ${(p) =>
    p.lum === LoginUserModeEnum.Impersonation
      ? p.theme.BACKGROUND_IMPERSONATION
      : p.theme.BACKGROUND_BASE};
  box-sizing: border-box;
  box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.1);
`

const SubPageHeader = () => {
  const loginUserMode = localStorage.getItem(
    LOGIN_USER_MODE
  ) as LoginUserModeEnum
  const { claims } = useAuthProvider()
  const destination = useMemo(() => {
    return claims?.role === UserRole.AGENT
      ? ROUTING_PATH.C0201
      : ROUTING_PATH.B0201
  }, [claims?.role])

  return (
    <>
      <HeaderContainer lum={loginUserMode}>
        <TopLogo to={destination} />
      </HeaderContainer>
      <GlobalMenu />
      <ReturnLink />
    </>
  )
}
export default SubPageHeader
